import { render, staticRenderFns } from "./ErrorLabel.vue?vue&type=template&id=dde6ac9c&"
import script from "./ErrorLabel.vue?vue&type=script&lang=ts&"
export * from "./ErrorLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports